export default "__VITE_ASSET__V_83ZaGU__"